import PropTypes from 'prop-types';
import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { Link } from 'react-router-dom';

import Button from 'react-bootstrap/lib/Button';
import Col from 'react-bootstrap/lib/Col';
import Grid from 'react-bootstrap/lib/Grid';

import styles from './PricingBuyerEnterprise.module.scss';

export default class PricingBuyerEnterprise extends Component {
  static propTypes = {
    className: PropTypes.string,
    gradient: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.oneOf(['left', 'right']),
    ]),
    usersCount: PropTypes.string,
  };

  static defaultProps = {
    gradient: false,
    usersCount: '0',
  };

  constructor() {
    super();

    this.state = {
      visible: false,
    };
  }

  render() {
    const { className, gradient, usersCount, ...rest } = this.props;

    const { visible } = this.state;

    return (
      <VisibilitySensor
        partialVisibility
        delayedCall
        minTopValue={visible ? 0 : 100}
        active={!visible}
        onChange={(isVisible) => this.setState({ visible: isVisible })}
      >
        <div
          className={
            (gradient
              ? styles.gradient +
                ' ' +
                (gradient === 'left'
                  ? styles.gradientLeft
                  : styles.gradientRight)
              : styles.noGradient) + (className ? ' ' + className : '')
          }
          {...rest}
        >
          <div className={styles.container}>
            <Grid>
              <Col xs={12} md={8} mdPush={2}>
                <h3
                  className={styles.title + (visible ? '' : ' ' + styles.hide)}
                >
                  Large projects & datasets
                </h3>
                <p
                  className={
                    styles.description + (visible ? '' : ' ' + styles.hide)
                  }
                >
                  With a global community of half a million freelancers, Twine
                  is experienced in delivering large projects with hundreds of
                  freelancers. This includes specialised audio and video
                  datasets for machine learning and AI research projects.
                  Projects are fully custom, flexible, and managed by us, with
                  each freelancer individually vetted to ensure quality for your
                  project.
                </p>
                <div
                  className={
                    styles.buttonContainer + (visible ? '' : ' ' + styles.hide)
                  }
                >
                  <Link to="/enterprise">
                    <Button bsStyle="success" className={styles.button}>
                      Learn more
                    </Button>
                  </Link>
                </div>
              </Col>
            </Grid>
          </div>
        </div>
      </VisibilitySensor>
    );
  }
}
